// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"65148ad1","207":"b0df87c1","729":"c0a7b05d","768":"2822a138","861":"9794d2ba","978":"f84e56c5"}[chunkId] + ".chunk.css";
};